import { FC } from 'react';
import { Alert, Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { dailyNavDateTimeLabel } from 'common/constants/dailyNav';
import { DayConfigBannerProps } from './DayConfigBanner.props';

// Only what the operator has to ACT on; the rules themselves live on FirmRulesIcon's
// hover. A warning behind a hover is a warning nobody sees, so these stay standing --
// and both are rare by construction.
const DayConfigBanner: FC<DayConfigBannerProps> = ({ config, isStale, unanchoredCount, firmSettingsUrl }) => {
  if (!isStale && unanchoredCount === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      {/* isStale is false for any historical date, so this only fires for the day in
          progress, where applying is still possible. */}
      {isStale && config && (
        <Alert severity="warning" data-testid="daily-nav-day-config-banner">
          <Typography variant="body2">
            These numbers are being evaluated under the settings in effect since{' '}
            <strong>{dailyNavDateTimeLabel(config.firm_config_effective_from)}</strong>. Newer settings have been saved
            but not applied to this day — they take effect on the next NAV day.
            {firmSettingsUrl && (
              <>
                {' '}
                <Link component={RouterLink} to={firmSettingsUrl} data-testid="daily-nav-day-config-settings-link">
                  Daily NAV settings
                </Link>
              </>
            )}
          </Typography>
        </Alert>
      )}

      {unanchoredCount > 0 && (
        <Alert severity="error" sx={{ mt: isStale ? 1 : 0 }} data-testid="daily-nav-unanchored-alert">
          {/* Matches the backend's unevaluable_reason; the cause is logged there. */}
          {unanchoredCount} row{unanchoredCount === 1 ? '' : 's'} on this date {unanchoredCount === 1 ? 'is' : 'are'}{' '}
          not anchored to any config version, so the rules {unanchoredCount === 1 ? 'it was' : 'they were'} evaluated
          under can no longer be identified. Please contact support.
        </Alert>
      )}
    </Box>
  );
};

export default DayConfigBanner;
